export default "__VITE_ASSET__QkRoGcgn__"